"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _MoveList = require("./MoveList.style");

var MoveList =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(MoveList, _Component);

  function MoveList() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, MoveList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(MoveList)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "clickedUp", function (event) {
      var _this$props = _this.props,
          position = _this$props.position,
          onPressUp = _this$props.onPressUp;
      onPressUp(event, position);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "clickedDown", function (event) {
      var _this$props2 = _this.props,
          position = _this$props2.position,
          onPressDown = _this$props2.onPressDown;
      onPressDown(event, position);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "clickedDelete", function (event) {
      var _this$props3 = _this.props,
          position = _this$props3.position,
          onPressDelete = _this$props3.onPressDelete;
      onPressDelete(event, position);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "clickedEdit", function (event) {
      var _this$props4 = _this.props,
          position = _this$props4.position,
          onPressEdit = _this$props4.onPressEdit;
      onPressEdit(event, position);
    });
    return _this;
  }

  (0, _createClass2.default)(MoveList, [{
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          position = _this$props5.position,
          listLength = _this$props5.listLength,
          disabledUp = _this$props5.disabledUp,
          disabledDown = _this$props5.disabledDown,
          disabledDelete = _this$props5.disabledDelete,
          disabledEdit = _this$props5.disabledEdit;
      return _react.default.createElement(_MoveList.StyledWrapper, null, !(disabledUp || position === 0) && _react.default.createElement(_MoveList.StyledButton, {
        role: "presentation",
        onClick: this.clickedUp
      }, _react.default.createElement(_Icon.default, {
        type: "arrow-up"
      })), !(disabledDown || position === listLength - 1) && _react.default.createElement(_MoveList.StyledButton, {
        role: "presentation",
        onClick: this.clickedDown
      }, _react.default.createElement(_Icon.default, {
        type: "arrow-down"
      })), !disabledDelete && _react.default.createElement(_MoveList.StyledButton, {
        role: "presentation",
        onClick: this.clickedDelete
      }, _react.default.createElement(_Icon.default, {
        type: "delete"
      })), !disabledEdit && _react.default.createElement(_MoveList.StyledButton, {
        role: "presentation",
        onClick: this.clickedEdit
      }, _react.default.createElement(_Icon.default, {
        type: "edit"
      })));
    }
  }]);
  return MoveList;
}(_react.Component);

MoveList.propTypes = {
  position: _propTypes.default.number.isRequired,
  listLength: _propTypes.default.number.isRequired,
  onPressUp: _propTypes.default.func,
  onPressDown: _propTypes.default.func,
  onPressDelete: _propTypes.default.func,
  disabledDelete: _propTypes.default.bool,
  disabledUp: _propTypes.default.bool,
  disabledDown: _propTypes.default.bool,
  disabledEdit: _propTypes.default.bool,
  onPressEdit: _propTypes.default.func
};
MoveList.defaultProps = {
  onPressUp: function onPressUp() {},
  onPressEdit: function onPressEdit() {},
  onPressDown: function onPressDown() {},
  onPressDelete: function onPressDelete() {},
  disabledDelete: false,
  disabledUp: false,
  disabledDown: false,
  disabledEdit: true
};
var _default = MoveList;
exports.default = _default;